import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/teacher/src/app/login/login.tsx");
